import qs from 'qs';

export const checkh5Sign = async (type: string, url: string, params: any) => {
    let w: any = window;
    const h5Sign = w?.h5sign;
    // 获取远程服务器下发配置，是否允许对请求签名
    let tapiUrl = {};

    let sign = null;
    if (type === 'get') {
        try {
            function strSpecialchar(prefix: any, value: any) {
                if (value === null || value === undefined) {
                    // eslint-disable-next-line no-param-reassign
                    value = '';
                }
                return value;
            }
            let paramsStr = decodeURIComponent(qs.stringify(params, { skipNulls: true }));
            sign = await h5Sign.sign(
                {
                    fullUrl: `https:${url}?${paramsStr}`,
                    type: 1,
                },
                undefined,
                {
                    ampParams: Object.fromEntries(
                        Object.entries(params).filter(([_, value]) =>
                            typeof value === 'string' && value?.includes?.('&')),
                    ),
                },
            );

        } catch (error) {}
    } else if (type === 'post') {
        try {
            try {
                let paramsStr = params;
                if (typeof paramsStr !== 'string') {
                    paramsStr = JSON.stringify(params);
                }
                sign = await h5Sign.sign(`https:${url}`, paramsStr);
            } catch (error) { }
        } catch (error) { }
    }
    return sign;
}